<template lang="pug">
div#page
  div#header
    b-navbar(fixed-top shadow spaced)
      template(#brand)
        b-navbar-item(tag="router-link" :to="{ path: '/' }")
          img(
            src="/bezahlde.gif"
            alt=""
            srcset=""
          )
      template(v-if="showNavigation()" #start)
        b-navbar-item(tag="router-link" :to="{ path: '/' }") Home
        b-navbar-dropdown(label="Config")
          b-navbar-item(tag="router-link" :to="{ path: '/merchant' }") Merchants
          b-navbar-item(tag="router-link" :to="{ path: '/organization' }") Organizations
          b-navbar-item(tag="router-link" :to="{ path: '/selector' }") Selectors
          b-navbar-item(tag="router-link" :to="{ path: '/tag' }") Tags
        b-navbar-item(tag="router-link" :to="{ path: '/status' }") Status

      template(v-if="showNavigation()" #end)
        b-navbar-item(tag="div")
          a(href="/nx.logout" aria-label="Login")
            b-button(
              label="Login"
              icon-left="login"
            )
  router-view(class="is-fluid")
</template>
<script>
export default {
  methods: {
    showNavigation() {
      return !this.$route.path.startsWith('/addOrder');
    },
  },
};
</script>
